import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import {
  Identifiable,
  Project,
  ProjectTimeSheet,
  TimeSheet,
  TimeSheetFilter,
} from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  timeSheet: ProjectTimeSheet;
  currentPage: number;
  canLoadMore: boolean;
  isDirty: boolean;
  retrieveProjectTimeSheet(
    request: Boundaries["retrieveProjectTimeSheet"]["request"],
  ): void;
}

function useRetrieveProjectTimeSheet(
  project: Identifiable<Project>,
  filter: TimeSheetFilter,
  size: number,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveProjectTimeSheetRequestPending(project, filter, size),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveProjectTimeSheetRequestSuccess(project, filter, size),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveProjectTimeSheetRequestFailure(project, filter, size),
    ),
    timeSheet: useSelector(() =>
      selector.getProjectTimeSheet(project, filter, size),
    ),
    currentPage: useSelector(() =>
      selector.getProjectTimeSheetCurrentPage(project, filter, size),
    ),
    canLoadMore: useSelector(() =>
      selector.canLoadMoreProjectTimeSheet(project, filter, size),
    ),
    isDirty: useSelector(() =>
      selector.isProjectTimeSheetDirty(project, filter, size),
    ),
    retrieveProjectTimeSheet: core.retrieveProjectTimeSheet,
  };
}

export { useRetrieveProjectTimeSheet };
